<template>
	<div class="card">
		<div class="card-body">
			<h5><i class="fas fa-plus-square"></i> Asignar certificado</h5>
			<p class="card-title-desc">
				Has click aquí para asignar un certificado ya creado.
			</p>
			<b-button 
				@click="modalAsignarCert()"
				block
			 	v-b-modal.modal-asignarCertificado 
				variant="success"
				v-if="jsonCoordinadora.privilegios"
				>
				<i class="fas fa-plus"></i>
				Asignar certificado
			</b-button>
			<PuSkeleton v-else :count="1"></PuSkeleton>
		</div>
		<modalAsignarCertificado ref="modalAsignarCertificado"/>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import modalAsignarCertificado from "@/components/certificado/modal/asignarCertificado";
export default {
	components: {
		modalAsignarCertificado
	},
	data() {
		return {};
	},
	computed:{
		...mapState('alumno',['jsonCoordinadora']),
	},
	methods:{
		modalAsignarCert(){

			this.$refs.modalAsignarCertificado.getInfoModal();
		}
	}
};
</script>
